<div class="flex-row header-wrapper">
  <h3>Terms of Use</h3>
  <button mat-icon-button aria-label="close dialog" mat-dialog-close class="button-close">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content class="main-text-font termOfUse-Content">
  <div class="content-wrapper">
    <p>
      This License Agreement (this "Agreement") is a legal agreement between DPC Data Inc. ("DPC") and the company by
      which you are employed or otherwise engaged (the "Company"). This Agreement governs Company's access to and use of
      any DPC Data® Filings Summary reports (including the information contained therein) that are made available to
      Company either directly at www.FilingsSummary.com or via a link from IPREO's web-based service (the "Reports").
    </p>
    <p>
      If you agree on behalf of the Company to the terms and conditions set forth in this Agreement and wish to access
      and
      use the Reports, please click on the "I Agree" button below. This will constitute a binding agreement between the
      Company and DPC. If you do not agree to the terms and conditions of this Agreement, please click the "Cancel"
      button. You will not be permitted to access or use the Reports unless you agree to the terms and conditions of
      this
      Agreement on behalf of the Company. If you agree to the terms and conditions of this Agreement, then these terms
      and
      conditions will apply to all subsequent access and use of Reports by Company, whether by you or by any other user.
    </p>
    <p>
      The Reports are copyrighted materials of DPC and/or its licensors. DPC grants Company a nonexclusive,
      nontransferable license, subject to the restrictions set forth in this Agreement, to use the Reports solely for
      Company's internal business purposes in the ordinary course of Company's business. Company will not disclose any
      Report or any portion thereof to anyone other than Company's employees and consultants who have a need to know the
      Report in connection with their responsibilities within or to Company's organization and who agree to be bound by
      all restrictions and obligations set forth herein to the same extent such restrictions and obligations apply to
      Company. Without limiting the foregoing, Company will not resell or otherwise distribute any Reports or
      information
      contained in the Reports.
    </p>
    <p>
      DPC makes no representation or warranty with regard to the accuracy or completeness of the information contained
      within any Reports. DPC relies on third party information in preparing the Reports. Such third party information
      may
      contain errors or omissions. DPC shall have no liability for any errors or omissions with respect to the Reports.
    </p>
    <p>
      The Reports do not reflect any information that was not available to DPC as of the effective date of this Report.
      DPC has no obligation to update the Reports with any such information.
    </p>
    <p>
      DPC provides the Reports solely for informational purposes. In no event will any Report be construed as an opinion
      by DPC with respect to any compliance or non-compliance by any issuer or obligor that is the subject of a Report
      with its continuing disclosure obligations, or as to the materiality of any information contained in a Report.
      Company is solely responsible for making any determinations with respect to the foregoing matters.
    </p>
    <p>
      Neither DPC nor any company or person affiliated with DPC, nor any of its or their respective employees, officers,
      directors, agents, suppliers or licensors (collectively, the "DPC Parties") will be liable to Company (or to any
      person claiming rights derived from Company's rights) for any consequential, incidental, indirect, punitive,
      special
      or exemplary damages of any kind (or for any lost revenues or profits, damage to reputation or goodwill or losses
      associated with diminished investor interest or increased borrowing costs), in each case with respect to any claim
      based on contract tort or otherwise (including negligence and strict liability) arising out of or relating to the
      Reports, Company's or any third party's use of any data or information contained in the Reports, or otherwise
      arising out of or relating to this Agreement, regardless of whether DPC or any other DPC party was advised, had
      other reason to know, or in fact know of the possibility thereof.
    </p>
    <p>
      The maximum, aggregate liability of DPC and the other DPC Parties in any way due to, resulting from, or arising in
      connection with the Reports, Company's or any third party's use of any data or information contained in the
      Reports,
      or otherwise arising out of or relating to this Agreement will not exceed, in the aggregate, One Hundred U.S.
      Dollars ($100).
    </p>
    <p>
      This Agreement sets forth the entire agreement of the parties as to its subject matter and supersedes all prior
      agreements, negotiations, representations, and promises between them with respect to its subject matter. This
      Agreement is binding upon and will inure to the benefit of each of the parties and their respective successors and
      assigns. This Agreement, and any and all disputes directly or indirectly arising out of or relating to this
      Agreement, will be governed by and construed in accordance with the laws of the State of New York, without
      reference
      to the choice of law rules thereof.
    </p></div>
</mat-dialog-content>
